import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { FaFileCircleCheck, FaFileCircleExclamation } from 'react-icons/fa6';

const ContractCard = ({ title, onView, isSigned }) => {
    return (
        <div className="bg-white border rounded-lg shadow p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
            {!isSigned ?
                <div className='flex items-center gap-2'>

                    <FaFileCircleExclamation size={30} />
                    <h3 className={`text-lg font-semibold`}>{title}</h3>
                </div>
                :
                <div className='flex items-center gap-2'>
                    <FaFileCircleCheck size={30} className='text-p-green' />
                    <h3 className={`text-lg font-semibold text-blue-500`}>{title}</h3>
                </div>
            }
            <div className="flex gap-2 mt-4 sm:mt-0">

                {!isSigned ? (
                    <button
                        onClick={onView}
                        className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-2 rounded-xl shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out"
                    >
                        Revisar y Firmar
                    </button>
                ) : (
                    <span className="text-p-green font-bold flex items-center gap-1"><FaCheckCircle /> Contrato Firmado</span>
                )}
            </div>
        </div>
    );
};

export default ContractCard;